import React, { useEffect, useState } from "react";
import {
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { useAlert, useAxios } from "../../hooks";
import { TextField } from "../../components";
import { CancelButton, PrimaryLoadingButton } from "../css components/Button";
import { colors } from "../css components/Style";

export default function AddMoneyDialog({
  setCreditAdded,
  addMoney,
  setAddMoney,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const { activeBrand, email } = useSelector((state) => state.memberDetails);

  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setAddMoney(false);
  };

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  }, []);

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = () => {
    axios({
      url: "/create/order",
      method: "POST",
      data: {
        receipt: activeBrand?.brandName,
        amount: parseFloat(amount),
        currency: "INR",
        notes: {
          description: `${activeBrand?.brandName} payment`,
        },
      },
    }).then((response) => {
      if (response.status) {
        handleClose();

        const resp = response.data;
        const options = {
          key: "rzp_test_YvrK73CThtiq9m",
          amount: resp.amount,
          currency: resp.currency,
          order_id: resp.transaction_id,
          name: activeBrand?.brandName,
          description: "Please proceed with your payment.",
          handler: function (responses) {
            if (responses) {
              axios({
                url: "/verify/order",
                method: "POST",
                data: {
                  order_id: responses.razorpay_order_id,
                  payment_id: responses.razorpay_payment_id,
                  signature: responses.razorpay_signature,
                },
              }).then((verify) => {
                if (verify.status) {
                  setCreditAdded(true);
                  handleClose();
                  dispatch(
                    alert({
                      type: "success",
                      message: "Credits added successfully!",
                    })
                  );
                }
              });
            }
          },
          prefill: {
            email: email,
            contact: "7905866225",
          },
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      }
    });
  };

  return (
    <MUIDialog
      open={addMoney}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          minWidth: "400px",
        },
      }}
    >
      <DialogContent>
        <Grid container spacing={4}>
          <Grid size={12} textAlign="center">
            <Typography variant="h6" sx={{ color: colors.green }}>
              Add Credits
            </Typography>
          </Grid>

          <Grid size={12}>
            <TextField
              type="number"
              size="small"
              label="Enter Credits"
              placeholder="Enter Credits"
              value={amount}
              onChange={(e) => {
                const val = e.target.value;
                if (val.length > 6) {
                  setMessage("You can add credits in lakhs");
                  return;
                }
                if (!isNaN(val)) {
                  setMessage("");
                  setAmount(val);
                }
              }}
            />
            {message && (
              <Typography sx={{ mt: 1 }} color={colors.error}>
                {message}
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <PrimaryLoadingButton
          onClick={handlePayment}
          variant="contained"
          disabled={parseInt(amount) < 0 || !amount}
        >
          Add Credits
        </PrimaryLoadingButton>
        <CancelButton onClick={handleClose} variant="outlined">
          Cancel
        </CancelButton>
      </DialogActions>
    </MUIDialog>
  );
}
